import {prepareT as prepareTNoExtract} from 'store/i18n'

// eslint-disable-next-line import/no-unresolved
import Links from 'plugin/deployment/links.json'

export default [
  {
    href: Links.about,
    label: prepareTNoExtract('Qui sommes nous\u00A0?'),
  },
  {
    href: Links.news,
    label: prepareTNoExtract('Actualités'),
  },
  {
    href: Links.contact,
    label: prepareTNoExtract('Prenons contact'),
  },
  {
    href: Links.connect,
    label: prepareTNoExtract('Mon espace personnel'),
  },
] as const
